module.exports = __webpack_public_path__ + "static/media/rom9.f4c5e55c.jpg";